import { SectionHeaderProps } from '../section-header/SectionHeader/SectionHeader'
import { ContentDataTypes } from '@news-mono/web-common'
import { ThemeMargins } from '../__styling/settings/metrics'

export interface SectionHeaderNavLink {
    text: string
    link: string
}
export interface CollectionRouteProps {
    sectionHeader?: SectionHeaderProps
    verticalSpacing?: keyof ThemeMargins | undefined
}

export const calculateExpectedCardCountFromContentData = (
    data: ContentDataTypes,
): number => {
    if (data === undefined) {
        throw new Error(
            'calculateExpectedCardCountFromContentData received no data',
        )
    }
    if (data.type === 'aggregated') {
        return data.sources.reduce((acc, val) => {
            if (val.type === 'listing') {
                acc += val.paging.pageSize
            } else if (val.type === 'curation') {
                acc += val.pageSize
            }
            return acc
        }, 0)
    } else if (data.type !== 'listing') {
        return data.pageSize
    }
    // Single topic listing
    return data.paging.pageSize
}
